import { FraudSummary, FraudSummaryCard } from './fraud-overview.models';

export function buildSummaryCards(summary: FraudSummary): FraudSummaryCard[] {
  return [
    {
      label: 'خودروهای تحت پایش',
      value: summary.iMonitoredVehicles,
      note: 'پایش فعال',
      accent: 'blue',
      numberFormat: '1.0-0',
    },
    {
      label: 'پرونده‌های شناسایی‌شده',
      value: summary.iTotalCases,
      note: 'روز انتخاب‌شده',
      accent: 'purple',
      numberFormat: '1.0-0',
    },
    {
      label: 'در انتظار بررسی',
      value: summary.iPendingCases,
      note: 'نیازمند بررسی',
      accent: 'orange',
      numberFormat: '1.0-0',
    },
    {
      label: 'تقلب تأیید شده',
      value: summary.iConfirmedCases,
      note: 'بررسی کارشناسی',
      accent: 'green',
      numberFormat: '1.0-0',
    },
    {
      label: 'بیشترین امتیاز تقلب',
      value: summary.fMaxFraudScore,
      note: 'از ۱۰۰ امتیاز',
      accent: 'red',
      numberFormat: '1.2-2',
    },
  ];
}
